var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"69csgoskins-最好的饰品体验！"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }